"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTaskFormFieldViewModel = exports.UserTaskViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class UserTaskViewModel extends ActivityViewModel_1.ActivityViewModel {
    constructor(userTask, processModel) {
        super(userTask, processModel);
        this.assignedUsersConfig = userTask.assignedUsersConfig;
        this.customForm = userTask.customForm;
        this.formFields = {};
        userTask.formFields.forEach((formField, index) => {
            this.formFields[formField.id] = new UserTaskFormFieldViewModel(formField, index);
        });
    }
}
exports.UserTaskViewModel = UserTaskViewModel;
class UserTaskFormFieldViewModel {
    constructor(userTaskFormField, index) {
        this.id = userTaskFormField.id;
        this.label = userTaskFormField.label;
        this.type = userTaskFormField.type;
        this.defaultValue = userTaskFormField.defaultValue;
        this.index = index;
    }
}
exports.UserTaskFormFieldViewModel = UserTaskFormFieldViewModel;
//# sourceMappingURL=UserTaskViewModel.js.map